import React, { useMemo } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { CardBody, Button, Input } from "reactstrap";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
} from "@mui/x-data-grid";
import { GeneralModal } from "./GeneralModal";
import ReactTableActions from "./components/ReactTableActions";
import Modal from "../../shared/components/Modal";
import {
  DatePicker,
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import moment from "moment";
import GetAppIcon from "@material-ui/icons/GetApp";
import { IconButton } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  title: {
    fontWeight: 600,
  },
  button: {
    display: "flex",
    justifyContent: "flex-end",
  },
  paper: {
    borderRadius: theme.spacing(1),
    display: "flex",
    flexGrow: 1,
    width: "100%",
    flexDirection: "column",
  },
  dataGridContainer: {
    border: "none",
    "& .MuiDataGrid-columnHeaders": {
      backgroundColor: theme.palette.grey[50],
    },
    "& .MuiDataGrid-row.evenRow": {
      backgroundColor: "#E5E8E8",
      "&:hover": {
        backgroundColor: "#D9EDFF" + " !important",
      },
    },
    "& .MuiDataGrid-row.oddRow": {
      backgroundColor: "#ffffff !important",
      "&:hover": {
        backgroundColor: "#D9EDFF" + " !important",
      },
    },
  },
  root: {
    "& .headerTable": {
      backgroundColor: "#7bbc6a !important",
    },
  },
}));

export function CustomToolbar({ dataCompleta = [] }) {
  const usuario = JSON.parse(sessionStorage.getItem("usuario"));
  const id_perfil = usuario?.id_perfil;

  if (id_perfil !== 9) {
    return null;
  }

  const encabezadosPersonalizados = {
    fecha_creacion: "𝗙𝗘𝗖𝗛𝗔 𝗖𝗥𝗘𝗔𝗖𝗜𝗢𝗡",
  nombre_tipo_persona: "𝗧𝗜𝗣𝗢 𝗣𝗘𝗥𝗦𝗢𝗡𝗔",
  nit: "𝗡𝗜𝗧",
  razon_social: "𝗥𝗔𝗭𝗢𝗡 𝗦𝗢𝗖𝗜𝗔𝗟",
  nombre_tipo_contribuyente: "𝗧𝗜𝗣𝗢 𝗖𝗢𝗡𝗧𝗥𝗜𝗕𝗨𝗬𝗘𝗡𝗧𝗘",
  renta: "𝗥𝗘𝗡𝗧𝗔",
  iva: "𝗜𝗩𝗔",
  cod_ciiu_principal: "𝗖𝗜𝗜𝗨 𝗣𝗥𝗜𝗡𝗖𝗜𝗣𝗔𝗟",
  cod_ciiu_act_2: "𝗖𝗜𝗜𝗨 𝗔𝗖𝗧𝗜𝗩𝗜𝗗𝗔𝗗 𝟮",
  cod_ciiu_act_3: "𝗖𝗜𝗜𝗨 𝗔𝗖𝗧𝗜𝗩𝗜𝗗𝗔𝗗 𝟯",
  nombre_pais: "𝗣𝗔𝗜𝗦",
  nombre_dpto: "𝗗𝗘𝗣𝗔𝗥𝗧𝗔𝗠𝗘𝗡𝗧𝗢",
  nombre_ciu: "𝗖𝗜𝗨𝗗𝗔𝗗",
  direccion: "𝗗𝗜𝗥𝗘𝗖𝗖𝗜𝗢𝗡",
  celular: "𝗖𝗘𝗟𝗨𝗟𝗔𝗥",
  email: "𝗘𝗠𝗔𝗜𝗟",
  cod_tipo_documento: "𝗧𝗜𝗣𝗢 𝗗𝗢𝗖𝗨𝗠𝗘𝗡𝗧𝗢",
  numero_identificacion: "𝗡𝗨𝗠𝗘𝗥𝗢 𝗜𝗗𝗘𝗡𝗧𝗜𝗙𝗜𝗖𝗔𝗖𝗜𝗢𝗡",
  nombre: "𝗡𝗢𝗠𝗕𝗥𝗘 𝗥𝗘𝗣𝗥𝗘𝗦𝗘𝗡𝗧𝗔𝗡𝗧𝗘",
  cargo: "𝗖𝗔𝗥𝗚𝗢",
  celular_representante: "𝗖𝗘𝗟𝗨𝗟𝗔𝗥 𝗥𝗘𝗣𝗥𝗘𝗦𝗘𝗡𝗧𝗔𝗡𝗧𝗘",
  email_representante: "𝗘𝗠𝗔𝗜𝗟 𝗥𝗘𝗣𝗥𝗘𝗦𝗘𝗡𝗧𝗔𝗡𝗧𝗘",
  };

  const fields = Object.keys(encabezadosPersonalizados);

  const handleExportarTodo = () => {
    if (dataCompleta.length === 0) {
      alert("No hay datos para exportar");
      return;
    }

    const datosFiltrados = dataCompleta.map((row) => {
      let filaFiltrada = {};
      fields.forEach((field) => {
        // Conseguimos el nombre bonito que le toca a esta columna
        const nombreBonitoHeader = encabezadosPersonalizados[field];
        let valor = row[field];

        if (typeof valor === "boolean") {
          valor = valor ? "SI" : "NO";
        }

        filaFiltrada[nombreBonitoHeader] =
          valor !== undefined && valor !== null ? valor : "";
      });
      return filaFiltrada;
    });

    const worksheet = XLSX.utils.json_to_sheet(datosFiltrados);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Proveedores");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const dataBlob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });

    const nombreArchivo = `Proveedores_${moment().format("YYYY-MM-DD_HH-mm-ss")}.xlsx`;

    saveAs(dataBlob, nombreArchivo);
  };

  return (
    <div
      style={{ display: "flex", justifyContent: "flex-end", paddingBlock: 8 }}
    >
      <GridToolbarContainer>
        <Button
          startIcon={<GetAppIcon />}
          style={{ fontSize: "0.97rem", textTransform: "uppercase" }}
          onClick={handleExportarTodo}
        >
          Exportar
        </Button>
      </GridToolbarContainer>
    </div>
  );
}

export function CustomNoRowsOverlay() {
  return (
    <div
      style={{ padding: "50px 0px", marginTop: "30px", textAlign: "center" }}
    >
      <Typography variant="body1" color="textSecondary">
        {`No hay ${title.toLowerCase()} registradas.`}
      </Typography>
    </div>
  );
}

export function GeneralTable({
  title,
  titleAlert,
  buttonText,
  columns,
  rows,
  modalFields,
  initialFormData,
  onSaveModal,
  historyUrl = undefined,
  actionsList = [],
  onActivate,
  onInactivate,
  enableActivate = false,
  /* onUpdate, */
  enableUpdate = false,
  enableDocumentarytype = false,
  enableView = false,
  requiredFields,
  loadList,
  enableActions = true,
  formData: formDataProp = undefined,
  setFormData: setFormDataProp = undefined,
  width,
  isModalRol = undefined,
  isModalDocument = undefined,
  isDocumentaryView = undefined,
  isEditMode = false,
  setIsEditMode = undefined,
  isModalRadication = undefined,
  isModalUser = undefined,
  rowCount,
  pageSize,
  page,
  handlePageSizeChange,
  handlePageChange,
  loadRemitente = undefined,
  isRadicacion,
  dates,
  setDates,
  consultarRegistro = undefined,
  listAllRegister = undefined,
}) {
  const classes = useStyles();
  const getRowColorClassName = React.useCallback(
    (params) => {
      const rowIndex = filteredRows.findIndex(
        (row) => (row.codigo ?? row.id ?? row.fecha_creacion) === params.id,
      );

      if (rowIndex === -1) {
        return ""; // Fila no encontrada
      }

      // Si el índice en el array (0, 1, 2, 3...) es PAR
      if (rowIndex % 2 === 0) {
        return "oddRow";
      }
      // Si es IMPAR
      return "evenRow";
    },
    [rows],
  );

  const [openModal, setOpenModal] = React.useState(false);
  const [isView, setIsView] = React.useState(false);
  const [formDataDefault, setFormDataDefault] = React.useState(
    initialFormData || {},
  );
  const [search, setSearch] = React.useState("");
  const [openAlert, setOpenAlert] = React.useState(false);
  const formData = formDataProp !== undefined ? formDataProp : formDataDefault;
  const usuario = JSON.parse(sessionStorage.getItem("usuario"));
  const id_perfil = usuario?.id_perfil;

  const setFormData =
    setFormDataProp !== undefined ? setFormDataProp : setFormDataDefault;

  const columns2 = useMemo(() => {
    const colms = columns.map((col) => ({
      ...col,
      headerClassName: "headerTable",
    }));
    if (enableActions) {
      colms.push({
        field: "actions",
        headerName: "ACCIONES",
        width: 250,
        disableColumnMenu: true,
        headerClassName: "headerTable",
        sortable: false,
        renderCell: (params) => {
          return ReactTableActions({
            data: params.row,
            loadList: loadList,
            titleAlert,
            setOpenModal,
            setFormData,
            historyUrl,
            actionsList,
            onActivate,
            onInactivate,
            enableActivate,
            enableUpdate,
            enableView,
            enableDocumentarytype,
            setIsView,
            isModalRol,
            setIsEditMode,
            consultarRegistro,
          });
        },
      });
    }
    return colms;
  }, []);

  const handleOpenModal = () => {
    setOpenModal(true);
    setIsEditMode?.(false);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setIsEditMode?.(false);
  };

  const handleFieldChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFieldChangeMini = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value.toLowerCase(),
    }));
  };

  const handleFieldChangeMay = async (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value.toUpperCase(),
    }));
  };

  const handleSave = async (validateForm, selectedFiles) => {
    try {
      await onSaveModal(formData, selectedFiles);
      handleCloseModal();
    } catch (error) {
      console.error("Error al guardar en la bd:", error);
    }
  };

  const CustomNoRowsOverlay = () => (
    <div
      style={{ padding: "50px 0px", marginTop: "30px", textAlign: "center" }}
    >
      <Typography variant="body1" color="textSecondary">
        {`No hay ${title.toLowerCase()} registradas.`}
      </Typography>
    </div>
  );

  const handleCloseAlert = async () => {
    setOpenAlert(false);
    loadRooms();
  };

  const filteredRows = rows.filter((row) =>
    Object.values(row).some((value) =>
      value?.toString().toLowerCase().includes(search.toLowerCase()),
    ),
  );

  return (
    <>
      <CardBody
        style={{
          padding: buttonText ? 30 : 0,
          paddingTop: 30,
        }}
      >
        <div className={classes.header}>
          <Typography variant="h5" className={classes.title}>
            {title}
          </Typography>
        </div>

        {buttonText && id_perfil === 9 && (
          <div className={classes.button}>
            <Button
              className="btn btn-sm"
              color="primary"
              onClick={handleOpenModal}
            >
              {buttonText}
            </Button>
          </div>
        )}
        <div
          className={classes.paper}
          style={{
            height:
              isModalRol || isModalDocument || isModalUser || isModalRadication
                ? 450
                : isDocumentaryView
                  ? 300
                  : 380,
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              marginBottom: 10,
              alignContent: "center",
              alignItems: "center",
            }}
          >
            <Input
              className="table__search table__search-input"
              value={search}
              style={{ width: "20%" }}
              onChange={(e) => {
                setSearch(e.target.value);
              }}
              placeholder={`Buscar...`}
            />
            {isRadicacion && (
              <MuiPickersUtilsProvider utils={MomentUtils}>
                <KeyboardDatePicker
                  disableFuture
                  variant="inline"
                  label="Fecha desde"
                  className="material-form__field"
                  style={{ width: 300, marginLeft: 20 }}
                  value={dates.start}
                  onChange={(date) => {
                    setDates({ ...dates, start: date });
                  }}
                  animateYearScrolling
                  autoOk={true}
                  format="yyyy/MM/D"
                />
                <KeyboardDatePicker
                  disableFuture
                  label="Fecha hasta"
                  className="material-form__field"
                  style={{ width: 300, marginLeft: 20 }}
                  value={dates.end}
                  onChange={(date) => {
                    setDates({ ...dates, end: date });
                  }}
                  animateYearScrolling
                  format="yyyy/MM/D"
                  autoOk={true}
                />
              </MuiPickersUtilsProvider>
            )}
          </div>

          <div style={{ height: 400, width: "100%" }} className={classes.root}>
            <DataGrid
              rows={filteredRows}
              columns={columns2}
              pagination
              paginationMode="server"
              pageSize={pageSize}
              rowsPerPageOptions={[5, 10, 15]}
              page={page}
              onPageChange={handlePageChange}
              onPageSizeChange={handlePageSizeChange}
              disableSelectionOnClick
              className={classes.dataGridContainer}
              getRowId={(row) => row.codigo ?? row.id ?? row.fecha_creacion}
              getRowClassName={getRowColorClassName}
              components={{
                NoRowsOverlay: CustomNoRowsOverlay,
                Toolbar:
                  buttonText === "Crear Proveedor" ? CustomToolbar : null,
              }}
              componentsProps={{
                toolbar: { dataCompleta: listAllRegister },
              }}
              rowCount={rowCount}
              localeText={{
                MuiTablePagination: {
                  labelRowsPerPage: "Filas por página:",
                  labelDisplayedRows: ({ from, to, count }) =>
                    `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`,
                  backIconButtonText: "Página anterior",
                  nextIconButtonText: "Página siguiente",
                },
                toolbarExport: "Exportar",
                toolbarExportCSV: "Descargar como CSV",
              }}
            />
          </div>
        </div>
        {modalFields && openModal && (
          <GeneralModal
            open={openModal}
            titleAlert={titleAlert}
            onClose={handleCloseModal}
            fields={modalFields}
            formData={formData}
            setFormData={setFormData}
            onFieldChange={handleFieldChange}
            onFieldChangeMini={handleFieldChangeMini}
            onFieldChangeMay={handleFieldChangeMay}
            onSave={handleSave}
            initialFormData={initialFormData}
            //enableDocumentarytype={enableDocumentarytype}
            isView={isView}
            setIsView={setIsView}
            requiredFields={requiredFields}
            width={width}
            isModalRol={isModalRol}
            enableUpdate={enableUpdate}
            isEditMode={isEditMode}
            setIsEditMode={setIsEditMode}
            isModalRadication={isModalRadication}
            isModalUser={isModalUser}
          />
        )}
      </CardBody>
      <Modal
        color="warning"
        title={`¿Esta seguro que desea aprobar esta versión?`}
        modal={openAlert}
        onOk={handleCloseAlert}
        toggle={() => setIsdeleted(!isdelete)}
      />
    </>
  );
}
